module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_bci.2172f560.svg";